import { CoopInfo } from './vo/coop-info.model';
import { GetMediumListResponse } from '../../../commons/kymw02/api-services/get-medium-list.service';

/**
 * 生協間コピー設定画面の値を管理するクラス
 *
 * @export KYMW4402Model
 * @class KYMW4402Model
 */
export class KYMW4402Model {
  mediumType: string;
  orderCode: string;
  catalogId: string;
  coopCode: string;

  mediumList: GetMediumListResponse = [];
  copyCoopList: CoopInfo[];

  get dspMediumType(): string {
    const name = this.mediumList?.find(
      _ => this.mediumType === _.MediumType
    )?.MediumName;
    if (!name) return '';
    return this.mediumType + ':' + name;
  }

  get dspCoopCode(): string {
    const name = this.copyCoopList?.find(
      _ => this.coopCode === _.coopCode
    )?.coopName;
    if (!name) return '';
    return this.coopCode + ':' + name;
  }

  get checkedCoopCodes(): string {
    const li = this.copyCoopList
      .filter(_ => _.check)
      .filter(_ => this.coopCode !== _.coopCode)
      .map(_ => _.coopCode);
    if (li) return li.join(',');
    return '';
  }
}
